var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClasses,style:(_vm.componentStyles),on:{"click":function($event){return _vm.emitClick()}}},[_c('header-simple',{attrs:{"header-text":_vm.headerText,"icon":'forward'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }